import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Pagamentos from '../../../modulos/pagamentos/containers/Pagamentos';

class PagamentosNavegacao extends React.Component {
    render(){
        return (            
            <Switch>
                <Route exact path={`${this.props.match.path}/:idpromotora/:idevento/:idpedido/:fonte/:linguagem`} component={Pagamentos} />
            </Switch>
        )
    }
}

export default PagamentosNavegacao;